var _mask, _ellipse, _path, _mask2, _ellipse2, _path2, _mask3, _ellipse3, _path3, _mask4, _ellipse4, _path4, _mask5, _ellipse5, _path5, _mask6, _ellipse6, _path6, _mask7, _ellipse7, _path7, _mask8, _ellipse8, _path8, _path9, _path0, _line, _line2, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _mask9, _ellipse9, _path19, _mask0, _ellipse0, _path20, _mask1, _ellipse1, _path21, _mask10, _ellipse10, _path22, _mask11, _ellipse11, _path23, _mask12, _ellipse12, _path24, _mask13, _ellipse13, _path25, _mask14, _ellipse14, _path26, _path27, _path28;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIconAstronaut1 = ({
  className,
  height = 80,
  titleId,
  title,
  ref,
  ...props
}) => {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 160 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    className: className,
    height: height,
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-1-inside-1_13586_175254",
    fill: "white"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 135.539,
    cy: 5.1073,
    rx: 1.6019,
    ry: 1.6073
  }))), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 135.539,
    cy: 5.1073,
    rx: 1.6019,
    ry: 1.6073,
    fill: "currentColor"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M137.141 5.1073H135.503C135.503 5.10771 135.503 5.10639 135.504 5.10391C135.504 5.10151 135.505 5.09902 135.506 5.09667C135.508 5.09219 135.51 5.08937 135.512 5.08754C135.514 5.08571 135.517 5.08295 135.523 5.08046C135.53 5.07749 135.537 5.0766 135.539 5.0766V6.7146V8.35259C137.334 8.35259 138.779 6.89443 138.779 5.1073H137.141ZM135.539 6.7146V5.0766C135.542 5.0766 135.549 5.07749 135.556 5.08046C135.562 5.08295 135.565 5.08571 135.567 5.08754C135.569 5.08937 135.571 5.09219 135.573 5.09667C135.574 5.09902 135.575 5.10151 135.575 5.10391C135.576 5.10639 135.575 5.10771 135.575 5.1073H133.938H132.3C132.3 6.89443 133.745 8.35259 135.539 8.35259V6.7146ZM133.938 5.1073H135.575C135.575 5.10689 135.576 5.1082 135.575 5.11069C135.575 5.11309 135.574 5.11558 135.573 5.11793C135.571 5.12241 135.569 5.12522 135.567 5.12706C135.565 5.12889 135.562 5.13164 135.556 5.13414C135.549 5.1371 135.542 5.138 135.539 5.138V3.5V1.862C133.745 1.862 132.3 3.32017 132.3 5.1073H133.938ZM135.539 3.5V5.138C135.537 5.138 135.53 5.1371 135.523 5.13414C135.517 5.13164 135.514 5.12889 135.512 5.12706C135.51 5.12522 135.508 5.12241 135.506 5.11793C135.505 5.11558 135.504 5.11309 135.504 5.11069C135.503 5.1082 135.503 5.10689 135.503 5.1073H137.141H138.779C138.779 3.32017 137.334 1.862 135.539 1.862V3.5Z",
    fill: "currentColor",
    mask: "url(#path-1-inside-1_13586_175254)"
  })), _mask2 || (_mask2 = /*#__PURE__*/React.createElement("mask", {
    id: "path-3-inside-2_13586_175254",
    fill: "white"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 159.053,
    cy: 27.396,
    rx: 0.947465,
    ry: 0.950657
  }))), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 159.053,
    cy: 27.396,
    rx: 0.947465,
    ry: 0.950657,
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M160 27.396H158.362C158.362 27.0216 158.666 26.7086 159.053 26.7086V28.3466V29.9846C160.486 29.9846 161.638 28.8204 161.638 27.396H160ZM159.053 28.3466V26.7086C159.439 26.7086 159.743 27.0216 159.743 27.396H158.105H156.467C156.467 28.8204 157.62 29.9846 159.053 29.9846V28.3466ZM158.105 27.396H159.743C159.743 27.7704 159.439 28.0833 159.053 28.0833V26.4453V24.8073C157.62 24.8073 156.467 25.9715 156.467 27.396H158.105ZM159.053 26.4453V28.0833C158.666 28.0833 158.362 27.7704 158.362 27.396H160H161.638C161.638 25.9715 160.486 24.8073 159.053 24.8073V26.4453Z",
    fill: "currentColor",
    mask: "url(#path-3-inside-2_13586_175254)"
  })), _mask3 || (_mask3 = /*#__PURE__*/React.createElement("mask", {
    id: "path-5-inside-3_13586_175254",
    fill: "white"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 0.947465,
    cy: 15.8452,
    rx: 0.947465,
    ry: 0.950657
  }))), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 0.947465,
    cy: 15.8452,
    rx: 0.947465,
    ry: 0.950657,
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1.89493 15.8452H0.256935C0.256935 15.4708 0.560907 15.1578 0.947465 15.1578V16.7958V18.4338C2.38056 18.4338 3.53293 17.2697 3.53293 15.8452H1.89493ZM0.947465 16.7958V15.1578C1.33402 15.1578 1.638 15.4708 1.638 15.8452H0H-1.638C-1.638 17.2697 -0.485634 18.4338 0.947465 18.4338V16.7958ZM0 15.8452H1.638C1.638 16.2196 1.33402 16.5325 0.947465 16.5325V14.8945V13.2565C-0.485634 13.2565 -1.638 14.4207 -1.638 15.8452H0ZM0.947465 14.8945V16.5325C0.560907 16.5325 0.256935 16.2196 0.256935 15.8452H1.89493H3.53293C3.53293 14.4207 2.38056 13.2565 0.947465 13.2565V14.8945Z",
    fill: "currentColor",
    mask: "url(#path-5-inside-3_13586_175254)"
  })), _mask4 || (_mask4 = /*#__PURE__*/React.createElement("mask", {
    id: "path-7-inside-4_13586_175254",
    fill: "white"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 21.9025,
    cy: 52.269,
    rx: 0.947465,
    ry: 0.950657
  }))), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 21.9025,
    cy: 52.269,
    rx: 0.947465,
    ry: 0.950657,
    fill: "currentColor"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M22.85 52.269H21.212C21.212 51.8946 21.516 51.5817 21.9025 51.5817V53.2197V54.8577C23.3356 54.8577 24.488 53.6935 24.488 52.269H22.85ZM21.9025 53.2197V51.5817C22.2891 51.5817 22.5931 51.8946 22.5931 52.269H20.9551H19.3171C19.3171 53.6935 20.4694 54.8577 21.9025 54.8577V53.2197ZM20.9551 52.269H22.5931C22.5931 52.6434 22.2891 52.9564 21.9025 52.9564V51.3184V49.6804C20.4694 49.6804 19.3171 50.8445 19.3171 52.269H20.9551ZM21.9025 51.3184V52.9564C21.516 52.9564 21.212 52.6434 21.212 52.269H22.85H24.488C24.488 50.8445 23.3356 49.6804 21.9025 49.6804V51.3184Z",
    fill: "currentColor",
    mask: "url(#path-7-inside-4_13586_175254)"
  })), _mask5 || (_mask5 = /*#__PURE__*/React.createElement("mask", {
    id: "path-9-inside-5_13586_175254",
    fill: "white"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 131.188,
    cy: 31.6157,
    rx: 0.947465,
    ry: 0.950657
  }))), _ellipse5 || (_ellipse5 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 131.188,
    cy: 31.6157,
    rx: 0.947465,
    ry: 0.950657,
    fill: "currentColor"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M132.135 31.6157H130.497C130.497 31.2413 130.801 30.9284 131.188 30.9284V32.5664V34.2043C132.621 34.2043 133.773 33.0402 133.773 31.6157H132.135ZM131.188 32.5664V30.9284C131.574 30.9284 131.878 31.2413 131.878 31.6157H130.24H128.602C128.602 33.0402 129.755 34.2043 131.188 34.2043V32.5664ZM130.24 31.6157H131.878C131.878 31.9901 131.574 32.303 131.188 32.303V30.665V29.027C129.755 29.027 128.602 30.1912 128.602 31.6157H130.24ZM131.188 30.665V32.303C130.801 32.303 130.497 31.9901 130.497 31.6157H132.135H133.773C133.773 30.1912 132.621 29.027 131.188 29.027V30.665Z",
    fill: "currentColor",
    mask: "url(#path-9-inside-5_13586_175254)"
  })), _mask6 || (_mask6 = /*#__PURE__*/React.createElement("mask", {
    id: "path-11-inside-6_13586_175254",
    fill: "white"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 123.022,
    cy: 76.2749,
    rx: 0.947465,
    ry: 0.950657
  }))), _ellipse6 || (_ellipse6 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 123.022,
    cy: 76.2749,
    rx: 0.947465,
    ry: 0.950657,
    fill: "currentColor"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M123.969 76.2749H122.331C122.331 75.9005 122.635 75.5875 123.022 75.5875V77.2255V78.8635C124.455 78.8635 125.607 77.6994 125.607 76.2749H123.969ZM123.022 77.2255V75.5875C123.408 75.5875 123.712 75.9005 123.712 76.2749H122.074H120.436C120.436 77.6994 121.589 78.8635 123.022 78.8635V77.2255ZM122.074 76.2749H123.712C123.712 76.6493 123.408 76.9622 123.022 76.9622V75.3242V73.6862C121.589 73.6862 120.436 74.8504 120.436 76.2749H122.074ZM123.022 75.3242V76.9622C122.635 76.9622 122.331 76.6493 122.331 76.2749H123.969H125.607C125.607 74.8504 124.455 73.6862 123.022 73.6862V75.3242Z",
    fill: "currentColor",
    mask: "url(#path-11-inside-6_13586_175254)"
  })), _mask7 || (_mask7 = /*#__PURE__*/React.createElement("mask", {
    id: "path-13-inside-7_13586_175254",
    fill: "white"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 34.1955,
    cy: 5.17624,
    rx: 0.947465,
    ry: 0.950657
  }))), _ellipse7 || (_ellipse7 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 34.1955,
    cy: 5.17624,
    rx: 0.947465,
    ry: 0.950657,
    fill: "currentColor"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M35.143 5.17624H33.505C33.505 4.80183 33.809 4.4889 34.1955 4.4889V6.1269V7.76489C35.6286 7.76489 36.781 6.60072 36.781 5.17624H35.143ZM34.1955 6.1269V4.4889C34.5821 4.4889 34.886 4.80183 34.886 5.17624H33.248H31.6101C31.6101 6.60072 32.7624 7.76489 34.1955 7.76489V6.1269ZM33.248 5.17624H34.886C34.886 5.55065 34.5821 5.86358 34.1955 5.86358V4.22559V2.58759C32.7624 2.58759 31.6101 3.75177 31.6101 5.17624H33.248ZM34.1955 4.22559V5.86358C33.809 5.86358 33.505 5.55065 33.505 5.17624H35.143H36.781C36.781 3.75177 35.6286 2.58759 34.1955 2.58759V4.22559Z",
    fill: "currentColor",
    mask: "url(#path-13-inside-7_13586_175254)"
  })), _mask8 || (_mask8 = /*#__PURE__*/React.createElement("mask", {
    id: "path-15-inside-8_13586_175254",
    fill: "white"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 2.26108,
    cy: 62.9706,
    rx: 1.6019,
    ry: 1.6073
  }))), _ellipse8 || (_ellipse8 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 2.26108,
    cy: 62.9706,
    rx: 1.6019,
    ry: 1.6073,
    fill: "currentColor"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M3.86299 62.9706H2.22499C2.22499 62.971 2.22497 62.9697 2.22548 62.9672C2.22597 62.9648 2.22674 62.9623 2.22773 62.9599C2.22962 62.9555 2.23179 62.9527 2.23362 62.9508C2.23544 62.949 2.23883 62.9462 2.24471 62.9437C2.2517 62.9408 2.25833 62.9399 2.26108 62.9399V64.5779V66.2159C4.05562 66.2159 5.50098 64.7577 5.50098 62.9706H3.86299ZM2.26108 64.5779V62.9399C2.26384 62.9399 2.27047 62.9408 2.27746 62.9437C2.28333 62.9462 2.28672 62.949 2.28855 62.9508C2.29038 62.9527 2.29255 62.9555 2.29443 62.9599C2.29542 62.9623 2.29619 62.9648 2.29668 62.9672C2.29719 62.9697 2.29717 62.971 2.29717 62.9706H0.65918H-0.978815C-0.978815 64.7577 0.466547 66.2159 2.26108 66.2159V64.5779ZM0.65918 62.9706H2.29717C2.29717 62.9702 2.29719 62.9715 2.29668 62.974C2.29619 62.9764 2.29542 62.9789 2.29443 62.9812C2.29255 62.9857 2.29038 62.9885 2.28855 62.9903C2.28672 62.9922 2.28333 62.9949 2.27746 62.9974C2.27047 63.0004 2.26384 63.0013 2.26108 63.0013V61.3633V59.7253C0.466547 59.7253 -0.978815 61.1835 -0.978815 62.9706H0.65918ZM2.26108 61.3633V63.0013C2.25833 63.0013 2.2517 63.0004 2.24471 62.9974C2.23883 62.9949 2.23544 62.9922 2.23362 62.9903C2.23179 62.9885 2.22962 62.9857 2.22773 62.9812C2.22674 62.9789 2.22597 62.9764 2.22548 62.974C2.22497 62.9715 2.22499 62.9702 2.22499 62.9706H3.86299H5.50098C5.50098 61.1835 4.05562 59.7253 2.26108 59.7253V61.3633Z",
    fill: "currentColor",
    mask: "url(#path-15-inside-8_13586_175254)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M23.085 23.6069C24.7533 23.6069 26.1102 24.9643 26.1104 26.645C26.1104 28.3258 24.7534 29.6841 23.085 29.6841C21.4165 29.6841 20.0596 28.3258 20.0596 26.645C20.0597 24.9643 21.4166 23.6069 23.085 23.6069Z",
    fill: "currentColor",
    stroke: "currentColor",
    strokeWidth: 1.638
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M131.426 56.3965C132.414 56.3967 133.22 57.2011 133.22 58.1992C133.22 59.1972 132.414 60.0018 131.426 60.002C130.438 60.002 129.632 59.1973 129.632 58.1992C129.632 57.201 130.438 56.3965 131.426 56.3965Z",
    fill: "currentColor",
    stroke: "currentColor",
    strokeWidth: 1.638
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 61.75,
    y1: 73.9756,
    x2: 61.75,
    y2: 66.4756,
    stroke: "currentColor",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 98.75,
    y1: 73.9756,
    x2: 98.75,
    y2: 66.4756,
    stroke: "currentColor",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M79.9953 50.2256C76.1717 50.2127 72.3779 49.544 68.7753 48.2478C68.6579 48.1995 68.5494 48.1317 68.4542 48.0471C65.9451 45.6984 64.1942 42.6389 63.4301 39.2681C62.666 35.8973 62.9242 32.3717 64.1709 29.1516C65.4176 25.9315 67.595 23.1664 70.4187 21.2173C73.2425 19.2682 76.5816 18.2256 80 18.2256C83.4184 18.2256 86.7575 19.2682 89.5813 21.2173C92.405 23.1664 94.5824 25.9315 95.8291 29.1516C97.0758 32.3717 97.334 35.8973 96.5699 39.2681C95.8058 42.6389 94.0549 45.6984 91.5458 48.0471C91.4486 48.1338 91.3366 48.2018 91.2153 48.2478C87.6129 49.5447 83.819 50.2134 79.9953 50.2256Z",
    stroke: "currentColor",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M79.9395 26.8252C82.2759 26.8252 84.3792 27.0907 86.0918 27.5615C87.8259 28.0383 89.0582 28.697 89.7637 29.4062L89.7656 29.4092C90.3266 29.9702 90.8078 31.0267 91.1094 32.4463C91.4029 33.8281 91.4909 35.3849 91.4023 36.7646L91.4014 36.7842C91.3639 37.5479 91.2544 38.5826 90.9785 39.5576C90.6949 40.5598 90.2827 41.3301 89.7598 41.7568L89.751 41.7637C88.9309 42.4451 87.5695 43.0351 85.8037 43.4482C84.0634 43.8553 82.0408 44.0654 80 44.0654C77.9593 44.0654 75.9384 43.8556 74.1924 43.4482C72.4246 43.0358 71.0428 42.4448 70.1865 41.7539H70.1875C69.6648 41.33 69.2572 40.563 68.9736 39.5547C68.6999 38.5813 68.5858 37.5484 68.5273 36.7627C68.453 35.3595 68.551 33.8038 68.8457 32.4287C69.1487 31.015 69.6232 29.9621 70.1738 29.3975C70.8776 28.6944 72.097 28.0399 73.8115 27.5645C75.5121 27.0929 77.6041 26.8252 79.9395 26.8252Z",
    stroke: "currentColor",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M99.1405 22.5256C98.517 22.5276 97.907 22.3445 97.3877 21.9996C96.8684 21.6546 96.4631 21.1634 96.2231 20.588C95.9832 20.0126 95.9194 19.3789 96.0398 18.7672C96.1602 18.1555 96.4594 17.5933 96.8995 17.1517C97.3397 16.7102 97.9009 16.4092 98.5123 16.2868C99.1236 16.1645 99.7574 16.2263 100.334 16.4644C100.91 16.7025 101.402 17.1063 101.749 17.6245C102.095 18.1427 102.28 18.7521 102.28 19.3756C102.28 20.2093 101.95 21.009 101.361 21.5994C100.773 22.1899 99.9742 22.5229 99.1405 22.5256ZM99.1405 18.2356C98.9122 18.2336 98.6885 18.2996 98.4978 18.4252C98.3072 18.5508 98.1582 18.7303 98.07 18.9408C97.9817 19.1514 97.9581 19.3834 98.0021 19.6074C98.0462 19.8314 98.1559 20.0373 98.3173 20.1987C98.4788 20.3601 98.6846 20.4699 98.9086 20.5139C99.1326 20.558 99.3647 20.5344 99.5752 20.4461C99.7857 20.3578 99.9652 20.2089 100.091 20.0182C100.216 19.8276 100.282 19.6039 100.28 19.3756C100.28 19.0732 100.16 18.7833 99.9466 18.5695C99.7328 18.3557 99.4428 18.2356 99.1405 18.2356Z",
    fill: "currentColor"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M99.1396 30.7454C98.8744 30.7454 98.6201 30.64 98.4325 30.4525C98.245 30.265 98.1396 30.0106 98.1396 29.7454V21.5254C98.1396 21.2602 98.245 21.0058 98.4325 20.8183C98.6201 20.6307 98.8744 20.5254 99.1396 20.5254C99.4049 20.5254 99.6592 20.6307 99.8468 20.8183C100.034 21.0058 100.14 21.2602 100.14 21.5254V29.7454C100.14 30.0106 100.034 30.265 99.8468 30.4525C99.6592 30.64 99.4049 30.7454 99.1396 30.7454Z",
    fill: "currentColor"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M108 75.2354V67.2354C108 58.3988 100.837 51.2354 92 51.2354V51.2354M52 75.2354V67.2354C52 58.3988 59.1634 51.2354 68 51.2354V51.2354",
    stroke: "currentColor",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M68.5 48.2256V52.2256C70.1667 52.8923 74.9 54.2256 80.5 54.2256C86.1 54.2256 90.1667 52.8923 91.5 52.2256V48.2256",
    stroke: "currentColor",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M63 30.2256H61C59.8954 30.2256 59 31.121 59 32.2256V38.2256C59 39.3302 59.8954 40.2256 61 40.2256H63",
    stroke: "currentColor",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M97 40.2256L99 40.2256C100.105 40.2256 101 39.3302 101 38.2256L101 32.2256C101 31.121 100.105 30.2256 99 30.2256L97 30.2256",
    stroke: "currentColor",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M104.542 13.7371C104.542 13.7371 102.76 11.7774 99.6418 11.6293C96.5237 11.4812 94.5639 13.2632 94.5639 13.2632",
    stroke: "currentColor",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M108.461 10.1728C108.461 10.1728 105.491 6.90659 99.8785 6.64002C94.2659 6.37344 90.9996 9.3435 90.9996 9.3435",
    stroke: "currentColor",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
export const Icon = ({
  className: propClassName = "",
  fill = "none",
  stroke = "currentColor",
  weight = "normal",
  height = 80,
  titleId,
  title,
  ref,
  ...props
}) => {
  const className = "vector-effect-non-scaling-stroke " + propClassName;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 160 80",
    fill: fill,
    xmlns: "http://www.w3.org/2000/svg",
    className: className,
    height: height,
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _mask9 || (_mask9 = /*#__PURE__*/React.createElement("mask", {
    id: "path-1-inside-1_13586_175254",
    fill: "white"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 135.539,
    cy: 5.1073,
    rx: 1.6019,
    ry: 1.6073
  }))), _ellipse9 || (_ellipse9 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 135.539,
    cy: 5.1073,
    rx: 1.6019,
    ry: 1.6073,
    fill: "currentColor"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M137.141 5.1073H135.503C135.503 5.10771 135.503 5.10639 135.504 5.10391C135.504 5.10151 135.505 5.09902 135.506 5.09667C135.508 5.09219 135.51 5.08937 135.512 5.08754C135.514 5.08571 135.517 5.08295 135.523 5.08046C135.53 5.07749 135.537 5.0766 135.539 5.0766V6.7146V8.35259C137.334 8.35259 138.779 6.89443 138.779 5.1073H137.141ZM135.539 6.7146V5.0766C135.542 5.0766 135.549 5.07749 135.556 5.08046C135.562 5.08295 135.565 5.08571 135.567 5.08754C135.569 5.08937 135.571 5.09219 135.573 5.09667C135.574 5.09902 135.575 5.10151 135.575 5.10391C135.576 5.10639 135.575 5.10771 135.575 5.1073H133.938H132.3C132.3 6.89443 133.745 8.35259 135.539 8.35259V6.7146ZM133.938 5.1073H135.575C135.575 5.10689 135.576 5.1082 135.575 5.11069C135.575 5.11309 135.574 5.11558 135.573 5.11793C135.571 5.12241 135.569 5.12522 135.567 5.12706C135.565 5.12889 135.562 5.13164 135.556 5.13414C135.549 5.1371 135.542 5.138 135.539 5.138V3.5V1.862C133.745 1.862 132.3 3.32017 132.3 5.1073H133.938ZM135.539 3.5V5.138C135.537 5.138 135.53 5.1371 135.523 5.13414C135.517 5.13164 135.514 5.12889 135.512 5.12706C135.51 5.12522 135.508 5.12241 135.506 5.11793C135.505 5.11558 135.504 5.11309 135.504 5.11069C135.503 5.1082 135.503 5.10689 135.503 5.1073H137.141H138.779C138.779 3.32017 137.334 1.862 135.539 1.862V3.5Z",
    fill: "currentColor",
    mask: "url(#path-1-inside-1_13586_175254)"
  })), _mask0 || (_mask0 = /*#__PURE__*/React.createElement("mask", {
    id: "path-3-inside-2_13586_175254",
    fill: "white"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 159.053,
    cy: 27.396,
    rx: 0.947465,
    ry: 0.950657
  }))), _ellipse0 || (_ellipse0 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 159.053,
    cy: 27.396,
    rx: 0.947465,
    ry: 0.950657,
    fill: "currentColor"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M160 27.396H158.362C158.362 27.0216 158.666 26.7086 159.053 26.7086V28.3466V29.9846C160.486 29.9846 161.638 28.8204 161.638 27.396H160ZM159.053 28.3466V26.7086C159.439 26.7086 159.743 27.0216 159.743 27.396H158.105H156.467C156.467 28.8204 157.62 29.9846 159.053 29.9846V28.3466ZM158.105 27.396H159.743C159.743 27.7704 159.439 28.0833 159.053 28.0833V26.4453V24.8073C157.62 24.8073 156.467 25.9715 156.467 27.396H158.105ZM159.053 26.4453V28.0833C158.666 28.0833 158.362 27.7704 158.362 27.396H160H161.638C161.638 25.9715 160.486 24.8073 159.053 24.8073V26.4453Z",
    fill: "currentColor",
    mask: "url(#path-3-inside-2_13586_175254)"
  })), _mask1 || (_mask1 = /*#__PURE__*/React.createElement("mask", {
    id: "path-5-inside-3_13586_175254",
    fill: "white"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 0.947465,
    cy: 15.8452,
    rx: 0.947465,
    ry: 0.950657
  }))), _ellipse1 || (_ellipse1 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 0.947465,
    cy: 15.8452,
    rx: 0.947465,
    ry: 0.950657,
    fill: "currentColor"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M1.89493 15.8452H0.256935C0.256935 15.4708 0.560907 15.1578 0.947465 15.1578V16.7958V18.4338C2.38056 18.4338 3.53293 17.2697 3.53293 15.8452H1.89493ZM0.947465 16.7958V15.1578C1.33402 15.1578 1.638 15.4708 1.638 15.8452H0H-1.638C-1.638 17.2697 -0.485634 18.4338 0.947465 18.4338V16.7958ZM0 15.8452H1.638C1.638 16.2196 1.33402 16.5325 0.947465 16.5325V14.8945V13.2565C-0.485634 13.2565 -1.638 14.4207 -1.638 15.8452H0ZM0.947465 14.8945V16.5325C0.560907 16.5325 0.256935 16.2196 0.256935 15.8452H1.89493H3.53293C3.53293 14.4207 2.38056 13.2565 0.947465 13.2565V14.8945Z",
    fill: "currentColor",
    mask: "url(#path-5-inside-3_13586_175254)"
  })), _mask10 || (_mask10 = /*#__PURE__*/React.createElement("mask", {
    id: "path-7-inside-4_13586_175254",
    fill: "white"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 21.9025,
    cy: 52.269,
    rx: 0.947465,
    ry: 0.950657
  }))), _ellipse10 || (_ellipse10 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 21.9025,
    cy: 52.269,
    rx: 0.947465,
    ry: 0.950657,
    fill: "currentColor"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M22.85 52.269H21.212C21.212 51.8946 21.516 51.5817 21.9025 51.5817V53.2197V54.8577C23.3356 54.8577 24.488 53.6935 24.488 52.269H22.85ZM21.9025 53.2197V51.5817C22.2891 51.5817 22.5931 51.8946 22.5931 52.269H20.9551H19.3171C19.3171 53.6935 20.4694 54.8577 21.9025 54.8577V53.2197ZM20.9551 52.269H22.5931C22.5931 52.6434 22.2891 52.9564 21.9025 52.9564V51.3184V49.6804C20.4694 49.6804 19.3171 50.8445 19.3171 52.269H20.9551ZM21.9025 51.3184V52.9564C21.516 52.9564 21.212 52.6434 21.212 52.269H22.85H24.488C24.488 50.8445 23.3356 49.6804 21.9025 49.6804V51.3184Z",
    fill: "currentColor",
    mask: "url(#path-7-inside-4_13586_175254)"
  })), _mask11 || (_mask11 = /*#__PURE__*/React.createElement("mask", {
    id: "path-9-inside-5_13586_175254",
    fill: "white"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 131.188,
    cy: 31.6157,
    rx: 0.947465,
    ry: 0.950657
  }))), _ellipse11 || (_ellipse11 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 131.188,
    cy: 31.6157,
    rx: 0.947465,
    ry: 0.950657,
    fill: "currentColor"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M132.135 31.6157H130.497C130.497 31.2413 130.801 30.9284 131.188 30.9284V32.5664V34.2043C132.621 34.2043 133.773 33.0402 133.773 31.6157H132.135ZM131.188 32.5664V30.9284C131.574 30.9284 131.878 31.2413 131.878 31.6157H130.24H128.602C128.602 33.0402 129.755 34.2043 131.188 34.2043V32.5664ZM130.24 31.6157H131.878C131.878 31.9901 131.574 32.303 131.188 32.303V30.665V29.027C129.755 29.027 128.602 30.1912 128.602 31.6157H130.24ZM131.188 30.665V32.303C130.801 32.303 130.497 31.9901 130.497 31.6157H132.135H133.773C133.773 30.1912 132.621 29.027 131.188 29.027V30.665Z",
    fill: "currentColor",
    mask: "url(#path-9-inside-5_13586_175254)"
  })), _mask12 || (_mask12 = /*#__PURE__*/React.createElement("mask", {
    id: "path-11-inside-6_13586_175254",
    fill: "white"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 123.022,
    cy: 76.2749,
    rx: 0.947465,
    ry: 0.950657
  }))), _ellipse12 || (_ellipse12 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 123.022,
    cy: 76.2749,
    rx: 0.947465,
    ry: 0.950657,
    fill: "currentColor"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M123.969 76.2749H122.331C122.331 75.9005 122.635 75.5875 123.022 75.5875V77.2255V78.8635C124.455 78.8635 125.607 77.6994 125.607 76.2749H123.969ZM123.022 77.2255V75.5875C123.408 75.5875 123.712 75.9005 123.712 76.2749H122.074H120.436C120.436 77.6994 121.589 78.8635 123.022 78.8635V77.2255ZM122.074 76.2749H123.712C123.712 76.6493 123.408 76.9622 123.022 76.9622V75.3242V73.6862C121.589 73.6862 120.436 74.8504 120.436 76.2749H122.074ZM123.022 75.3242V76.9622C122.635 76.9622 122.331 76.6493 122.331 76.2749H123.969H125.607C125.607 74.8504 124.455 73.6862 123.022 73.6862V75.3242Z",
    fill: "currentColor",
    mask: "url(#path-11-inside-6_13586_175254)"
  })), _mask13 || (_mask13 = /*#__PURE__*/React.createElement("mask", {
    id: "path-13-inside-7_13586_175254",
    fill: "white"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 34.1955,
    cy: 5.17624,
    rx: 0.947465,
    ry: 0.950657
  }))), _ellipse13 || (_ellipse13 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 34.1955,
    cy: 5.17624,
    rx: 0.947465,
    ry: 0.950657,
    fill: "currentColor"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M35.143 5.17624H33.505C33.505 4.80183 33.809 4.4889 34.1955 4.4889V6.1269V7.76489C35.6286 7.76489 36.781 6.60072 36.781 5.17624H35.143ZM34.1955 6.1269V4.4889C34.5821 4.4889 34.886 4.80183 34.886 5.17624H33.248H31.6101C31.6101 6.60072 32.7624 7.76489 34.1955 7.76489V6.1269ZM33.248 5.17624H34.886C34.886 5.55065 34.5821 5.86358 34.1955 5.86358V4.22559V2.58759C32.7624 2.58759 31.6101 3.75177 31.6101 5.17624H33.248ZM34.1955 4.22559V5.86358C33.809 5.86358 33.505 5.55065 33.505 5.17624H35.143H36.781C36.781 3.75177 35.6286 2.58759 34.1955 2.58759V4.22559Z",
    fill: "currentColor",
    mask: "url(#path-13-inside-7_13586_175254)"
  })), _mask14 || (_mask14 = /*#__PURE__*/React.createElement("mask", {
    id: "path-15-inside-8_13586_175254",
    fill: "white"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 2.26108,
    cy: 62.9706,
    rx: 1.6019,
    ry: 1.6073
  }))), _ellipse14 || (_ellipse14 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 2.26108,
    cy: 62.9706,
    rx: 1.6019,
    ry: 1.6073,
    fill: "currentColor"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M3.86299 62.9706H2.22499C2.22499 62.971 2.22497 62.9697 2.22548 62.9672C2.22597 62.9648 2.22674 62.9623 2.22773 62.9599C2.22962 62.9555 2.23179 62.9527 2.23362 62.9508C2.23544 62.949 2.23883 62.9462 2.24471 62.9437C2.2517 62.9408 2.25833 62.9399 2.26108 62.9399V64.5779V66.2159C4.05562 66.2159 5.50098 64.7577 5.50098 62.9706H3.86299ZM2.26108 64.5779V62.9399C2.26384 62.9399 2.27047 62.9408 2.27746 62.9437C2.28333 62.9462 2.28672 62.949 2.28855 62.9508C2.29038 62.9527 2.29255 62.9555 2.29443 62.9599C2.29542 62.9623 2.29619 62.9648 2.29668 62.9672C2.29719 62.9697 2.29717 62.971 2.29717 62.9706H0.65918H-0.978815C-0.978815 64.7577 0.466547 66.2159 2.26108 66.2159V64.5779ZM0.65918 62.9706H2.29717C2.29717 62.9702 2.29719 62.9715 2.29668 62.974C2.29619 62.9764 2.29542 62.9789 2.29443 62.9812C2.29255 62.9857 2.29038 62.9885 2.28855 62.9903C2.28672 62.9922 2.28333 62.9949 2.27746 62.9974C2.27047 63.0004 2.26384 63.0013 2.26108 63.0013V61.3633V59.7253C0.466547 59.7253 -0.978815 61.1835 -0.978815 62.9706H0.65918ZM2.26108 61.3633V63.0013C2.25833 63.0013 2.2517 63.0004 2.24471 62.9974C2.23883 62.9949 2.23544 62.9922 2.23362 62.9903C2.23179 62.9885 2.22962 62.9857 2.22773 62.9812C2.22674 62.9789 2.22597 62.9764 2.22548 62.974C2.22497 62.9715 2.22499 62.9702 2.22499 62.9706H3.86299H5.50098C5.50098 61.1835 4.05562 59.7253 2.26108 59.7253V61.3633Z",
    fill: "currentColor",
    mask: "url(#path-15-inside-8_13586_175254)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M23.085 23.6069C24.7533 23.6069 26.1102 24.9643 26.1104 26.645C26.1104 28.3258 24.7534 29.6841 23.085 29.6841C21.4165 29.6841 20.0596 28.3258 20.0596 26.645C20.0597 24.9643 21.4166 23.6069 23.085 23.6069Z",
    fill: "currentColor",
    stroke: stroke,
    strokeWidth: 1.638
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.426 56.3965C132.414 56.3967 133.22 57.2011 133.22 58.1992C133.22 59.1972 132.414 60.0018 131.426 60.002C130.438 60.002 129.632 59.1973 129.632 58.1992C129.632 57.201 130.438 56.3965 131.426 56.3965Z",
    fill: "currentColor",
    stroke: stroke,
    strokeWidth: 1.638
  }), /*#__PURE__*/React.createElement("line", {
    x1: 61.75,
    y1: 73.9756,
    x2: 61.75,
    y2: 66.4756,
    stroke: stroke,
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 98.75,
    y1: 73.9756,
    x2: 98.75,
    y2: 66.4756,
    stroke: stroke,
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.9953 50.2256C76.1717 50.2127 72.3779 49.544 68.7753 48.2478C68.6579 48.1995 68.5494 48.1317 68.4542 48.0471C65.9451 45.6984 64.1942 42.6389 63.4301 39.2681C62.666 35.8973 62.9242 32.3717 64.1709 29.1516C65.4176 25.9315 67.595 23.1664 70.4187 21.2173C73.2425 19.2682 76.5816 18.2256 80 18.2256C83.4184 18.2256 86.7575 19.2682 89.5813 21.2173C92.405 23.1664 94.5824 25.9315 95.8291 29.1516C97.0758 32.3717 97.334 35.8973 96.5699 39.2681C95.8058 42.6389 94.0549 45.6984 91.5458 48.0471C91.4486 48.1338 91.3366 48.2018 91.2153 48.2478C87.6129 49.5447 83.819 50.2134 79.9953 50.2256Z",
    stroke: stroke,
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.9395 26.8252C82.2759 26.8252 84.3792 27.0907 86.0918 27.5615C87.8259 28.0383 89.0582 28.697 89.7637 29.4062L89.7656 29.4092C90.3266 29.9702 90.8078 31.0267 91.1094 32.4463C91.4029 33.8281 91.4909 35.3849 91.4023 36.7646L91.4014 36.7842C91.3639 37.5479 91.2544 38.5826 90.9785 39.5576C90.6949 40.5598 90.2827 41.3301 89.7598 41.7568L89.751 41.7637C88.9309 42.4451 87.5695 43.0351 85.8037 43.4482C84.0634 43.8553 82.0408 44.0654 80 44.0654C77.9593 44.0654 75.9384 43.8556 74.1924 43.4482C72.4246 43.0358 71.0428 42.4448 70.1865 41.7539H70.1875C69.6648 41.33 69.2572 40.563 68.9736 39.5547C68.6999 38.5813 68.5858 37.5484 68.5273 36.7627C68.453 35.3595 68.551 33.8038 68.8457 32.4287C69.1487 31.015 69.6232 29.9621 70.1738 29.3975C70.8776 28.6944 72.097 28.0399 73.8115 27.5645C75.5121 27.0929 77.6041 26.8252 79.9395 26.8252Z",
    stroke: stroke,
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M99.1405 22.5256C98.517 22.5276 97.907 22.3445 97.3877 21.9996C96.8684 21.6546 96.4631 21.1634 96.2231 20.588C95.9832 20.0126 95.9194 19.3789 96.0398 18.7672C96.1602 18.1555 96.4594 17.5933 96.8995 17.1517C97.3397 16.7102 97.9009 16.4092 98.5123 16.2868C99.1236 16.1645 99.7574 16.2263 100.334 16.4644C100.91 16.7025 101.402 17.1063 101.749 17.6245C102.095 18.1427 102.28 18.7521 102.28 19.3756C102.28 20.2093 101.95 21.009 101.361 21.5994C100.773 22.1899 99.9742 22.5229 99.1405 22.5256ZM99.1405 18.2356C98.9122 18.2336 98.6885 18.2996 98.4978 18.4252C98.3072 18.5508 98.1582 18.7303 98.07 18.9408C97.9817 19.1514 97.9581 19.3834 98.0021 19.6074C98.0462 19.8314 98.1559 20.0373 98.3173 20.1987C98.4788 20.3601 98.6846 20.4699 98.9086 20.5139C99.1326 20.558 99.3647 20.5344 99.5752 20.4461C99.7857 20.3578 99.9652 20.2089 100.091 20.0182C100.216 19.8276 100.282 19.6039 100.28 19.3756C100.28 19.0732 100.16 18.7833 99.9466 18.5695C99.7328 18.3557 99.4428 18.2356 99.1405 18.2356Z",
    fill: "currentColor"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M99.1396 30.7454C98.8744 30.7454 98.6201 30.64 98.4325 30.4525C98.245 30.265 98.1396 30.0106 98.1396 29.7454V21.5254C98.1396 21.2602 98.245 21.0058 98.4325 20.8183C98.6201 20.6307 98.8744 20.5254 99.1396 20.5254C99.4049 20.5254 99.6592 20.6307 99.8468 20.8183C100.034 21.0058 100.14 21.2602 100.14 21.5254V29.7454C100.14 30.0106 100.034 30.265 99.8468 30.4525C99.6592 30.64 99.4049 30.7454 99.1396 30.7454Z",
    fill: "currentColor"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M108 75.2354V67.2354C108 58.3988 100.837 51.2354 92 51.2354V51.2354M52 75.2354V67.2354C52 58.3988 59.1634 51.2354 68 51.2354V51.2354",
    stroke: stroke,
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.5 48.2256V52.2256C70.1667 52.8923 74.9 54.2256 80.5 54.2256C86.1 54.2256 90.1667 52.8923 91.5 52.2256V48.2256",
    stroke: stroke,
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63 30.2256H61C59.8954 30.2256 59 31.121 59 32.2256V38.2256C59 39.3302 59.8954 40.2256 61 40.2256H63",
    stroke: stroke,
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97 40.2256L99 40.2256C100.105 40.2256 101 39.3302 101 38.2256L101 32.2256C101 31.121 100.105 30.2256 99 30.2256L97 30.2256",
    stroke: stroke,
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.542 13.7371C104.542 13.7371 102.76 11.7774 99.6418 11.6293C96.5237 11.4812 94.5639 13.2632 94.5639 13.2632",
    stroke: stroke,
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.461 10.1728C108.461 10.1728 105.491 6.90659 99.8785 6.64002C94.2659 6.37344 90.9996 9.3435 90.9996 9.3435",
    stroke: stroke,
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
};
export default SvgIconAstronaut1;
export const raw = __webpack_public_path__ + "static/media/icon-astronaut-1.08d0a98692405c73ae489fe8a861b9ac.svg";